import { React, useEffect} from 'react'; 
import { useLocation } from 'react-router-dom';
import Hero from './Hero';
import Gallery from './Gallery';
import Classes from './Classes';
import Contact from './Contact';
import About from './About';

export default function Home() {

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const targetElement = document.querySelector(location.hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return (
        <>
            <Hero />
            <Gallery />
            <Classes />
            <About />
            <Contact />
        </>
    )
}